import { useState, useCallback } from 'react';

import { PreferredLocale } from '../../constants/cookies';
import { useUserSetting } from '../../hooks/use-user-setting';
import { LogService } from '../../services/log-service';
import { saveUserSetting } from '../../store/user/user.api';

export const useUserSettingLocale = () => {
  const localeFromSetting = useUserSetting(PreferredLocale);
  const [userSettingLocale, setUserSettingLocale] = useState(localeFromSetting);

  const updateUserSettingLocale = useCallback(
    (newLocale) => {
      setUserSettingLocale(newLocale);
      try {
        saveUserSetting({
          settingName: PreferredLocale,
          settingValue: newLocale,
        });
      } catch (e) {
        LogService.logWarning('Unable to save user Locale', {
          settingName: PreferredLocale,
          settingValue: newLocale,
          e,
        });
      }
    },
    [setUserSettingLocale],
  );

  return {
    userSettingLocale,
    setUserSettingLocale: updateUserSettingLocale,
  };
};
